'use client'

import { AnimatedSection } from '@/ui/animated-section'
import { ThinkingIndicator } from '@/ui/thinking-indicator'

interface AnalysisPanelProps {
  isAnalyzing: boolean
  hasContent: boolean
}

/**
 * AnalysisPanel displays AI analysis status and results.
 * Currently shows thinking indicator during analysis.
 * Future enhancements could include:
 * - Suggested tags/topics display
 * - Sentiment/mood indicators
 * - Apply suggestions buttons
 */
export function AnalysisPanel({ isAnalyzing, hasContent }: AnalysisPanelProps) {
  return (
    <AnimatedSection show={hasContent && isAnalyzing}>
      <ThinkingIndicator isThinking={isAnalyzing} />
    </AnimatedSection>
  )
}
